import { Instance, types } from 'mobx-state-tree';
import { MomentDate } from '@models/shared/MomentDate';

export const TimeSlotConfiguration = types.model('TimeSlotConfigurationModel', {
  startTime: MomentDate,
  endTime: MomentDate,
});

export type TimeSlotConfigurationModelType = Instance<typeof TimeSlotConfiguration>;
